import styled from 'styled-components';

interface IStyledCellEditorProps {
  cellHeight: string;
}

export const CellEditor = styled.div<IStyledCellEditorProps>`
  position: relative;
  height: 100%;

  .MuiFormControl-root {
    width: 100%;
    border-radius: 0;
    line-height: unset;
    height: 100%;
  }

  .MuiOutlinedInput-root {
    height: 100%;
    display: flex;
  }

  .MuiFormHelperText-root {
    margin-top: 0;
  }

  input {
    box-sizing: border-box;
    padding: 0 14px;
    height: auto;
  }
`;
